// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"75907e69","796":"f5077ed5"}[chunkId] + ".chunk.js";
};